import { http } from 'msw';

import { createGetToggleMfaQueryResponse } from '../mocks/createGetToggleMfa';

export const getToggleMfaHandler = http.get('*/toggle_mfa', function handler(info) {
  return new Response(JSON.stringify(createGetToggleMfaQueryResponse()), {
    headers: {
      'Content-Type': 'application/json',
    },
  });
});
